import { render, staticRenderFns } from "./PackageListItem.vue?vue&type=template&id=15a46276"
import script from "./PackageListItem.vue?vue&type=script&lang=js"
export * from "./PackageListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports